export const version = '1.3.0';
export const buildTime = 'Wed Sep 16 2026 10:02:58 GMT+0200 (Central European Summer Time)';
export const sourceUrl = 'https://github.com/CentreForDigitalHumanities/gen-ai-reflection/tree/c45fb397968e4f88c94072b2a1ebcb074c1048eb';
